export default __webpack_public_path__ + "static/media/person-add-black-24-dp.5b8ed67e.svg";